import type { svgPlaceType } from '../types'

import LogoIcon from './LogoIcon'

type Props = {
  isDarkMode?: boolean
} & svgPlaceType

export default function LogoBrandServer({ isDarkMode, ...props }: Props) {
  return <LogoIcon isDarkMode={isDarkMode} {...props} />
}
